import './styles.css';

const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
/* Start decorative animations only after the first frame has painted */
requestAnimationFrame(() => requestAnimationFrame(() => document.documentElement.classList.add('anim')));
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];

/* Nav */
const nav = $('#nav');
const menuBtn = $('#menuBtn');
const menu = $('#menu');
const onScroll = () => nav.classList.toggle('is-solid', window.scrollY > 12);
onScroll();
window.addEventListener('scroll', onScroll, { passive: true });
menuBtn.addEventListener('click', () => {
  const open = menuBtn.getAttribute('aria-expanded') === 'true';
  menuBtn.setAttribute('aria-expanded', String(!open));
  menuBtn.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
  menu.hidden = open;
  nav.classList.toggle('is-solid', !open || window.scrollY > 12);
});
$$('a', menu).forEach((a) => a.addEventListener('click', () => { menu.hidden = true; menuBtn.setAttribute('aria-expanded', 'false'); }));

/* Reveal on scroll, with a light stagger inside each section */
const reveals = $$('.reveal');
if (reduced) {
  reveals.forEach((el) => el.classList.add('is-in'));
} else {
  // Anything already inside the first viewport shows at once; only below the fold animates in.
  const vh = window.innerHeight;
  const groups = new Map();
  reveals.forEach((el) => {
    if (el.getBoundingClientRect().top < vh) { el.classList.add('is-in'); return; }
    const key = el.closest('section, footer') || document.body;
    const n = groups.get(key) || 0;
    el.style.setProperty('--d', `${Math.min(n, 5) * 0.05}s`);
    groups.set(key, n + 1);
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
  reveals.forEach((el) => { if (!el.classList.contains('is-in')) io.observe(el); });
}

/* Lead form return visitors (Meta lead ad "View website" link carries ?src=leadform) */
const leadBar = $('#leadBar');
if (leadBar && new URLSearchParams(location.search).get('src') === 'leadform' && !sessionStorage.getItem('leadbar-dismissed')) {
  leadBar.hidden = false;
  document.documentElement.classList.add('has-leadbar');
  $('#leadBarClose').addEventListener('click', () => {
    leadBar.hidden = true;
    document.documentElement.classList.remove('has-leadbar');
    try { sessionStorage.setItem('leadbar-dismissed', '1'); } catch {}
  });
}

/* Sticky CTA on mobile: show after the hero */
const sticky = $('#sticky');
const hero = $('.hero');
const estimate = $('#estimate');
if (sticky) {
  const check = () => {
    const past = hero.getBoundingClientRect().bottom < 0;
    const atForm = estimate.getBoundingClientRect().top < window.innerHeight * 0.6;
    sticky.classList.toggle('is-on', past && !atForm);
  };
  check();
  window.addEventListener('scroll', check, { passive: true });
}

/* Services: hover or focus swaps the stage image on desktop */
const services = $$('.service');
const stageImgs = $$('.stage__img');
function activate(li) {
  services.forEach((s) => s.classList.toggle('is-active', s === li));
  const key = li.dataset.img;
  stageImgs.forEach((img) => img.classList.toggle('is-on', img.dataset.key === key));
}
services.forEach((li) => {
  li.addEventListener('pointerenter', () => activate(li));
  li.addEventListener('focusin', () => activate(li));
});

/* Pre-select the reason in the form from any link that carries data-reason */
const reasonMap = { maintenance: 'Weekly or bi-weekly maintenance', green: 'Green to clean', repair: 'Repair', resurface: 'Resurface (plaster or pebble)', tile: 'Tile and coping', liner: 'Vinyl liner', remodel: 'Full remodel', build: 'New pool build', seasonal: 'Opening or closing' };
$$('[data-reason]').forEach((a) => {
  a.addEventListener('click', () => {
    const v = reasonMap[a.dataset.reason];
    const input = $$('#reasonPills input').find((i) => i.value === v);
    if (input) input.checked = true;
  });
});

/* Before and after slider */
const ba = $('#ba');
if (ba) {
  const range = $('#baRange');
  const set = (v) => { ba.style.setProperty('--pos', `${v}%`); };
  set(50);
  range.addEventListener('input', () => set(range.value));
  // Direct pointer drag anywhere on the image, so it feels like a real slider
  let dragging = false;
  const pos = (e) => {
    const r = ba.getBoundingClientRect();
    const x = Math.min(Math.max(e.clientX - r.left, 0), r.width);
    const v = Math.round((x / r.width) * 100);
    range.value = v;
    set(v);
  };
  ba.addEventListener('pointerdown', (e) => { dragging = true; pos(e); });
  window.addEventListener('pointermove', (e) => { if (dragging) pos(e); });
  window.addEventListener('pointerup', () => { dragging = false; });
}

/* Hero water. The poster (CSS water + duck) paints first. On phones the sim boots on the
   first touch or scroll, on desktop after load and idle, so it never lands in the critical path. */
const heroPool = $('#heroPool');
const heroCanvas = $('#heroCanvas');
const hint = $('#poolHint');
const renderMode = location.search.includes('render=');
if (heroCanvas && !renderMode) {
  const hasGL = (() => { try { const c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl')); } catch { return false; } })();
  if (!hasGL) {
    heroPool.classList.add('no-webgl');
  } else {
    let booted = false;
    const boot = () => {
      if (booted) return; booted = true;
      import('./hero-water.js').then(({ initHeroWater }) => {
        const api = initHeroWater(heroCanvas, { reduced });
        if (!api) { heroPool.classList.add('no-webgl'); return; }
        heroPool.classList.add('is-live');
        heroCanvas.addEventListener('webglcontextlost', (e) => { e.preventDefault(); api.destroy(); heroPool.classList.remove('is-live'); heroPool.classList.add('no-webgl'); }, false);
        let hid = false;
        const hide = () => { if (!hid) { hid = true; hint.classList.add('is-hidden'); } };
        heroCanvas.addEventListener('pointerdown', hide, { once: true, passive: true });
        heroCanvas.addEventListener('pointermove', hide, { once: true, passive: true });
      }).catch((err) => { console.error(err); heroPool.classList.add('no-webgl'); });
    };
    const coarse = matchMedia('(pointer: coarse)').matches || matchMedia('(max-width: 760px)').matches;
    const firstTouch = (e) => { boot(); };
    heroPool.addEventListener('pointerdown', firstTouch, { once: true, passive: true });
    heroPool.addEventListener('pointerenter', firstTouch, { once: true, passive: true });
    if (coarse) {
      window.addEventListener('scroll', firstTouch, { once: true, passive: true });
      window.addEventListener('touchstart', firstTouch, { once: true, passive: true });
    } else {
      // Desktop: first mouse move or scroll, whichever comes first. Keeps shader compile off the load trace.
      window.addEventListener('pointermove', firstTouch, { once: true, passive: true });
      window.addEventListener('scroll', firstTouch, { once: true, passive: true });
      window.addEventListener('keydown', firstTouch, { once: true, passive: true });
    }
  }
}

/* 3D pool designer, loads when the section is near the viewport */
const vizWrap = $('#vizWrap');
if (vizWrap) {
  let loaded = false;
  const bar = $('#vizBar'), loadText = $('#vizLoadText');
  const load = () => {
    if (loaded) return; loaded = true;
    import('./configurator.js').then(({ initConfigurator }) => {
      const api = initConfigurator({
        canvas: $('#vizCanvas'), wrap: vizWrap, reduced,
        ui: { shape: $('#vizShape'), finish: $('#vizFinish'), tile: $('#vizTile'), coping: $('#vizCoping'), deck: $('#vizDeck'), features: $('#vizFeatures'), time: $('#vizTime'), views: $('#vizViews'), note: $('#vizNote'), send: $('#vizCta') },
        onProgress: (p) => { if (bar) bar.style.width = `${Math.round(p * 100)}%`; },
        onReady: () => { $('#vizLoading').classList.add('is-done'); },
        onChange: (text) => { const f = $('#finishChoice'); if (f) f.value = text; },
      });
      if (!api) { $('#vizFallback').hidden = false; $('#vizLoading').classList.add('is-done'); return; }
      $('#vizCanvas').addEventListener('webglcontextlost', () => { $('#vizFallback').hidden = false; }, false);
      // "Send my design": preselect the build reason if nothing else is picked
      $('#vizCta')?.addEventListener('click', () => { const any = $$('#reasonPills input').some((i) => i.checked); if (!any) { const b = $$('#reasonPills input').find((i) => i.value === 'New pool build'); if (b) b.checked = true; } });
    }).catch((err) => { console.error(err); $('#vizFallback').hidden = false; $('#vizLoading').classList.add('is-done'); });
  };
  const io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) { load(); io.disconnect(); } }, { rootMargin: matchMedia('(max-width: 760px)').matches ? '300px 0px' : '600px 0px' });
  io.observe(vizWrap);
  if (renderMode) load();
}

/* Form: validate, post to Netlify, show state inline */
const form = $('#estimateForm');
if (form) {
  const status = $('#formStatus');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    status.className = 'form__status';
    status.textContent = '';
    let ok = true;
    $$('.field', form).forEach((f) => f.classList.remove('is-invalid'));
    ['name', 'phone', 'email', 'city_or_zip'].forEach((n) => {
      const el = form.elements[n];
      if (!el.value.trim() || (el.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(el.value))) { ok = false; el.closest('.field').classList.add('is-invalid'); }
    });
    if (!ok) { status.classList.add('is-error'); status.textContent = 'Please fill in your name, phone, email and city or ZIP.'; return; }
    const btn = form.querySelector('.form__submit');
    btn.disabled = true;
    status.textContent = 'Sending...';
    try {
      const res = await fetch(form.getAttribute('action') || '/', { method: 'POST', body: new FormData(form) });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      form.reset();
      form.classList.add('is-sent');
      status.textContent = '';
      const done = document.createElement('div');
      done.className = 'form__done';
      done.setAttribute('role', 'status');
      done.innerHTML = '<img src="/brand/duck-page.webp" width="120" height="104" alt="" /><h3>Got it.</h3><p>Hunter will call you to set up the visit. If it is urgent, call <a href="tel:+14707581230" data-cta="form-done-call">(470) 758-1230</a>.</p>';
      form.insertAdjacentElement('afterend', done);
      done.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    } catch (err) {
      // Fall back to a normal submit so Netlify can still catch it
      console.warn('Fetch submit failed, falling back to native submit', err);
      HTMLFormElement.prototype.submit.call(form);
    } finally {
      btn.disabled = false;
    }
  });
}

/* Design ideas tabs */
const dzTabs = $$('.dz__tab');
const dzShow = (tab, focus) => {
  dzTabs.forEach((t) => {
    const on = t === tab;
    t.classList.toggle('is-active', on);
    t.setAttribute('aria-selected', String(on));
    t.tabIndex = on ? 0 : -1;
    const panel = document.getElementById(`dz-${t.dataset.dz}`);
    panel.hidden = !on;
    panel.classList.toggle('is-active', on);
  });
  if (focus) tab.focus();
};
dzTabs.forEach((tab, i) => {
  tab.addEventListener('click', () => dzShow(tab));
  tab.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    const next = dzTabs[(i + (e.key === 'ArrowRight' ? 1 : dzTabs.length - 1)) % dzTabs.length];
    dzShow(next, true);
  });
});

/* Live 3D yard, loaded when the section gets close */
const s3d = document.getElementById('s3d');
if (s3d) {
  const gl = (() => { try { return !!document.createElement('canvas').getContext('webgl2'); } catch { return false; } })();
  if (!gl) s3d.querySelector('#s3dText').textContent = 'Your browser cannot show 3D, here is the yard';
  else {
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      Promise.all([import('./scene3d.js'), import('./designer.js')]).then(([{ initScene3d }, { initDesigner, readDesignFromUrl }]) => {
        const api = initScene3d(s3d, {
          url: '/3d/entertainer.glb',
          onProgress: (p) => { s3d.querySelector('#s3dBar').style.width = `${Math.round(p * 100)}%`; },
          onReady: () => s3d.classList.add('is-ready'),
          onError: () => { s3d.querySelector('#s3dText').textContent = 'The 3D yard did not load, here is the rendering'; },
        });
        if (location.search.includes('debug3d')) window.__s3d = api;
        api.ready.then(() => initDesigner(api, document.getElementById('dsg'), { initial: readDesignFromUrl() }));
      });
    }, { rootMargin: '600px' });
    io.observe(s3d);
  }
}
